import gql from 'graphql-tag';

export const GET_COMPANIES = gql`
  query GetCompanies($query: CompanyQuery!) {
    getCompanies(query: $query) {
      _id
      name
      address
      email
      ninea
      phoneNumber
    }
  }
`;
